import {QueryClient, QueryClientProvider} from "react-query";
import Box from "@mui/material/Box";
import React from "react";
import DailyReportPage from "./DailyReportPage";

export default function DashboardDailyReportPage() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <Box sx={{marginTop: 1, marginRight: 3}}>
                <DailyReportPage/>
            </Box>
        </QueryClientProvider>
    );
}
